import Vue from 'vue';

// import VueGtm from 'vue-gtm';
import VueProgressBar from 'vue-progressbar';
import VueObserveVisibility from 'vue-observe-visibility';
import 'intersection-observer';
import VueLazyImageLoading from 'vue-lazy-image-loading';
import VueSocialSharing from 'vue-social-sharing';
import {VueReCaptcha} from 'vue-recaptcha-v3';

import App from './App.vue';
import router from './router';
import store from './store';
import Axios from 'axios';

Vue.prototype.$http = Axios;

const token = localStorage.getItem('token');

if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token;
}

/* UNCOMMENT TO ENABLE CACHE import './registerServiceWorker'; */
/* UNCOMMENT TO ENABLE i18n import i18n from './i18n'; */

import meta from './assets/data/meta.json';

Vue.config.productionTip = false;

// if (meta.GTM !== 'GTM-XXXXXX') {
//     Vue.use(VueGtm, {
//         id: meta.GTM,
//         enabled: true,
//         debug: false,
//         vueRouter: router
//     });
// }

Vue.use(VueProgressBar, {
    color: meta.progressbarColor
});

Vue.use(VueSocialSharing);
Vue.use(VueObserveVisibility);
Vue.use(VueLazyImageLoading);
Vue.use(VueReCaptcha, {
    siteKey: '6LffH70UAAAAAKIYO09Y5sCW9ITLso_CVlRfO9iK',
    loaderOptions: {
        autoHideBadge: true
    }
});

new Vue({
    router,
    store,
    /* UNCOMMENT TO ENABLE i18n i18n, */
    render: h => h(App)
}).$mount('#app');
